import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const TextWrapper = styled.div`
  margin-inline: ${Spacing.S80};
`

export const FooterContentWrapper = styled.div`
  width: 100%;
`
